/*
 * @license
 * Copyright© Celligence LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";

export default function Loading() {
    return (
        <Container>
            <Row>
                <Col sm={12} className="text-center loadingSpinner mb-3">
                    <Spinner animation="border" variant="primary" />
                    <p className="loadingText">Loading...</p>
                </Col>
            </Row>
        </Container>
    )
};